import React from 'react';
import ActionGrade from 'material-ui/svg-icons/action/grade';

const yellow = {
    color:  "#ffba00"
}

export default class Grade extends React.Component {
  
    render()
    {
        var stars = [];

        for (var index = 0; index < this.props.grade; index++) {
            stars.push(<ActionGrade key={index} style={yellow} />)
        }

        return (
            <div>
                {stars}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Grade.js